import { Pipe, PipeTransform } from "@angular/core";
import dayjs from "@webapp/shared/libs/dayjs";
import { isDateInThePast } from "./utils";

@Pipe({
  name: "isDateInThePast",
  standalone: true,
})
export class IsDateInThePastPipe implements PipeTransform {
  public transform(date: string | dayjs.Dayjs | Date): boolean {
    return isDateInThePast(date);
  }
}
